module.exports = __webpack_public_path__ + "bb8d498307dea6fd203571644afdff12.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/eyes/unimpressed-31.png
// module id = 2365
// module chunks = 0